import { X } from "lucide-react";
import DetailRow from "../../../../UI/viewDialogs/DetailRow";
import HeadingDialog from "../../../../UI/viewDialogs/HeadingDialog";
import { timeStampToDateAndTime } from "../../../../../functions/dateTime/timeStampToDateAndTime";
import { getExpenseStatus } from "../../../../../functions/getExpenseStatus";
import { checkValue } from "../../../../../functions/checkValue";
import Modal from "../../../../portal/Modal";
import TabsView from "../../../../UI/viewDialogs/expense/TabsView";
import PictureList from "../../../../UI/viewDialogs/PictureList";
import { formatDate } from "../../../../../functions/dateTime/formatDate";

export default function ExpenseHistoryView({
  closeDialog,
  viewDetails,
  openImageSlider,
  setImageSliderCurrentIndex,
}) {
  const backDate = viewDetails.backDated ? (
    <span className="expense-view-bd">BD</span>
  ) : (
    ""
  );
  return (
    <Modal onClose={closeDialog} modalWidth="view-dialog-content" closeIcon={true}>
      <HeadingDialog heading="Expense Details" />
      <div className="h-600 px-2 overflow-auto">
        <div className="view-dialog-content-wrap">
          <DetailRow title="User" value={viewDetails.user.fullName} />
          <DetailRow title="Amount" value={`₹${viewDetails.amount}`} />
          <div className={`${getExpenseStatus(viewDetails.state).textColor}`}>
            <DetailRow
              title="Status"
              value={getExpenseStatus(viewDetails.state).status}
            />
          </div>
          <DetailRow
            title="Description"
            value={checkValue(viewDetails.description)}
            textJustify="text-justify"
            widthDesc="w-64"
          />
          {viewDetails.receiver && (
            <DetailRow
              title="Received By"
              value={viewDetails.receiver.fullName}
            />
          )}
          <DetailRow title="Date" value={formatDate(viewDetails.date)}>
            {backDate}
          </DetailRow>
          <DetailRow
            title="Created By"
            value={viewDetails.createdBy.fullName}
          />
          <DetailRow
            title="Created At"
            value={timeStampToDateAndTime(viewDetails.createdAt)}
          />
          <DetailRow
            title="Last Updated By"
            value={viewDetails.updatedBy.fullName}
          />
          <DetailRow
            title="Last Updated At"
            value={timeStampToDateAndTime(viewDetails.updatedAt)}
          />
        </div>
        {viewDetails.pictureList && (
          <PictureList
            pictureList={viewDetails.pictureList}
            openImageSlider={openImageSlider}
            setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          />
        )}
        <TabsView expenseViewDetails={viewDetails} />
      </div>
    </Modal>
  );
}
